<div mat-dialog-title>
	<div class="flex flex-row justify-between items-center -mt-8">
		<div class="flex flex-col">
			<div class="flex flex-wrap gap-2 mb-2">
				@for (tag of data.scale.tags; track tag.id) {
					<span
						class="px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-md border"
						[ngClass]="
							tag.color ||
							'bg-slate-100 text-slate-800 border-slate-200 dark:bg-slate-700 dark:text-slate-200 dark:border-slate-600'
						">
						{{ tag.label }}
					</span>
				}
			</div>
			<h1 class="text-2xl font-bold text-slate-900 dark:text-slate-100 m-0">{{ data.scale.label }}</h1>
		</div>
		<button
			mat-icon-button
			mat-dialog-close>
			<mat-icon>close</mat-icon>
		</button>
	</div>
</div>

<div mat-dialog-content>
	<p class="text-slate-600 dark:text-slate-400 mb-6">{{ data.scale.description }}</p>
	<div class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden">
		<div class="p-2 flex flex-col gap-2">
			@for (level of sortedLevels(); track level.id) {
				<div
					(click)="selectLevel(level)"
					class="p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 flex items-start gap-4"
					[ngClass]="{
						'border-primary bg-indigo-50/50 dark:bg-indigo-900/20': selectedLevel()?.id === level.id,
						'border-transparent hover:bg-white dark:hover:bg-slate-700 hover:shadow-sm':
							selectedLevel()?.id !== level.id,
					}">
					<div
						class="mt-1 flex-shrink-0 h-5 w-5 rounded-full border-2 flex items-center justify-center transition-colors"
						[ngClass]="
							selectedLevel()?.id === level.id
								? 'border-primary'
								: 'border-slate-300 dark:border-slate-600'
						">
						@if (selectedLevel()?.id === level.id) {
							<div class="h-2.5 w-2.5 bg-primary rounded-full"></div>
						}
					</div>

					<div class="flex-grow">
						<div class="flex items-center gap-2">
							<span class="font-bold text-slate-900 dark:text-slate-100">{{ level.label }}</span>
						</div>
						@if (level.description) {
							<div
								class="text-slate-600 dark:text-slate-400 text-xs mt-1 leading-relaxed"
								[innerHTML]="level.description"></div>
						}
					</div>
				</div>
			}
		</div>
	</div>
</div>
